import {Component, OnInit} from '@angular/core';
import {DossierService} from './dossier.service';
import {Insurer} from './Insurer';
import {Rendezvous} from '../auth/signin/rendezvous';
import {Router} from '@angular/router';
import {UserInformation} from './user-information';
import {UAParser} from 'ua-parser-js';

@Component({
  selector: 'app-dossier',
  templateUrl: './dossier.component.html',
  styleUrls: ['./dossier.component.css']
})
export class DossierComponent implements OnInit {
  referenceSinistre: string;
  insurer: Insurer;
  rendezvous: Rendezvous;
  messageError: string;
  PAGE_CONNEXION = '/auth/signin';
  TITRE_POPIN = 'Erreur';
  userInformation: UserInformation;
  cguIsChecked = false;
  cguIsShown = false;

  constructor(private dossierService: DossierService, private router: Router) {
  }

  parser: UAParser;

  ngOnInit() {
    this.referenceSinistre = localStorage.getItem('refSinistre');
    this.userInformation = new UserInformation();
    this.dossierService.getInsurer(localStorage.getItem('tokenConnexion')).subscribe((insurer: Insurer) => {
      if (!insurer || insurer.Id === 0) {
        this.messageError = 'Erreur lors de la connexion !!';
      } else {
        this.insurer = insurer;
        this.constructDateObject();
      }
    }, () => this.messageError = 'Erreur lors de la connexion !!');

  }

  disconnect() {
    localStorage.clear();
    this.router.navigate(['/auth/signin']);
  }

  startVisio() {
    if (this.cguIsChecked) {
      localStorage.setItem('canStartVisio', 'true');
      this.router.navigate(['/visio']);
      this.userInformation.Message = this.constructDeviceInformationString();
      this.dossierService.sendUserInformation(this.userInformation).subscribe(() => {
      });
    }
  }

  constructDeviceInformationString() {
    this.parser = new UAParser();
    const parsedUa = this.parser.getResult();
    let reponse = 'Dossier: ' + this.referenceSinistre + ', ';
    reponse += 'Browser: ' + parsedUa.browser.name + ', Version: ' + parsedUa.browser.version + ', ';
    reponse += 'Device: ' + parsedUa.device.vendor + '(' + parsedUa.device.type + ') ' + parsedUa.device.model + ', ';
    reponse += 'OS: ' + parsedUa.os.name + ' ' + parsedUa.os.version + ', ';
    reponse += 'Résolution: ' + window.screen.width + 'x' + window.screen.height;

    return reponse;
  }

  constructDateObject() {
    this.rendezvous = new Rendezvous();
    if (localStorage.getItem('rendezvous') != null) {
      this.rendezvous.begin = JSON.parse(localStorage.getItem('rendezvous')).begin.substring(6, 19);
      this.rendezvous.end = JSON.parse(localStorage.getItem('rendezvous')).end.substring(6, 19);
    }
  }

  onShowCgu() {
    this.cguIsShown = true;
  }

  onCloseCgu() {
    this.cguIsShown = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/dossier/dossier.component.ts